import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AsyncRichTextEditProps } from './AsyncRichTextEditProps.entrypoint.types.tsx';

type AsyncRichTextEditEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	AsyncRichTextEditProps,
	{} | null
>;

const asyncRichTextEditRoot = JSResourceForInteraction<AsyncRichTextEditEntryPointComponent>(
	/* webpackChunkName: "async-jira-issue-field-rich-text-entry" */ './EntryPointContent.tsx',
);

const baseEntryPoint: EntryPoint<AsyncRichTextEditEntryPointComponent, {}> = createEntryPoint({
	root: asyncRichTextEditRoot,
	getPreloadProps: () => ({}),
});

type PreloadableEntryPoint<TComponent, TParams extends {}> = EntryPoint<TComponent, TParams> & {
	preload: () => void;
};

export const preloadableAsyncRichTextEditEntryPoint: PreloadableEntryPoint<
	AsyncRichTextEditEntryPointComponent,
	{}
> = Object.assign(baseEntryPoint, {
	preload: () => asyncRichTextEditRoot.preload(),
});
